const FETCH_MY_STORY = 'studio/storyDetail/FETCH_MY_STORY';

const UPDATE_MY_STORY = 'studio/storyDetail/UPDATE_MY_STORY';

const FETCH_MY_STORY_EPISODES = 'studio/storyDetail/FETCH_MY_STORY_EPISODES';

const CREATE_MY_EPISODE = 'studio/storyDetail/CREATE_MY_EPISODE';

const REMOVE_MY_EPISODE = 'studio/storyDetail/REMOVE_MY_EPISODE';

const PATCH_MY_EPISODE = 'studio/storyDetail/PATCH_MY_EPISODE';

const RESET = 'studio/storyDetail/RESET';

const FETCH_READER_INFO = 'studio/storyDetail/FETCH_READER_INFO';

const CANCEL_BOOKED = 'studio/storyDetail/CANCEL_BOOKED';

const POST_EPISODE_STATISTIC = 'studio/storyDetail/POST_EPISODE_STATISTIC';

const FETCH_EPISODE_STATISTIC_VOUCHER_RECOMMENDATION =
  'studio/storyDetail/FETCH_EPISODE_STATISTIC_VOUCHER_RECOMMENDATION';

export default {
  FETCH_MY_STORY,
  UPDATE_MY_STORY,
  FETCH_MY_STORY_EPISODES,
  CREATE_MY_EPISODE,
  REMOVE_MY_EPISODE,
  PATCH_MY_EPISODE,
  RESET,
  FETCH_READER_INFO,
  CANCEL_BOOKED,
  POST_EPISODE_STATISTIC,
  FETCH_EPISODE_STATISTIC_VOUCHER_RECOMMENDATION,
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/storyDetail/types.js